(function () {
  if (window.revampMapInfoInit) {
    return;
  }

  window.revampMapInfoInit = true;
  window.revampMapInfoDragging = false;

  document.addEventListener(
    'click',
    function (event) {
      var closeBtn = event.target.closest('.map-info__close');
      if (closeBtn) {
        event.preventDefault();
        event.stopPropagation();
        var info = closeBtn.closest('.map-info');
        if (info) {
          info.classList.remove('is-open');
        }
        return;
      }

      if (window.revampMapInfoDragging) {
        event.preventDefault();
        event.stopPropagation();
        window.revampMapInfoDragging = false;
        return;
      }

      var backdrop = event.target.closest('.map-info__backdrop');
      if (backdrop) {
        event.preventDefault();
        event.stopPropagation();
        var backdropInfo = backdrop.closest('.map-info');
        if (backdropInfo) {
          backdropInfo.classList.remove('is-open');
        }
        return;
      }

      if (event.target.closest('.map-info__panel')) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.map-info__trigger');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      var info = trigger.closest('.map-info');
      var isOpen = info && info.classList.contains('is-open');
      document.querySelectorAll('.map-info.is-open').forEach(function (item) {
        item.classList.remove('is-open');
      });
      if (info && !isOpen) {
        info.classList.add('is-open');
      }
      return;
    }

    if (event.target.closest('.map-info__panel')) {
      return;
    }

    document.querySelectorAll('.map-info.is-open').forEach(function (item) {
      item.classList.remove('is-open');
    });
  });

  document.addEventListener('mousedown', function (event) {
    var header = event.target.closest('.map-info__header');
    if (!header || event.target.closest('.map-info__close')) {
      return;
    }

    var info = header.closest('.map-info');
    var panel = info ? info.querySelector('.map-info__panel') : null;
    if (!panel) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    window.revampMapInfoDragging = false;

    var rect = panel.getBoundingClientRect();
    var startX = event.clientX;
    var startY = event.clientY;
    var offsetX = startX - rect.left;
    var offsetY = startY - rect.top;

    panel.style.transform = 'none';
    panel.style.left = rect.left + 'px';
    panel.style.top = rect.top + 'px';

    var onMove = function (moveEvent) {
      var nextLeft = moveEvent.clientX - offsetX;
      var nextTop = moveEvent.clientY - offsetY;
      if (!window.revampMapInfoDragging) {
        var deltaX = Math.abs(moveEvent.clientX - startX);
        var deltaY = Math.abs(moveEvent.clientY - startY);
        if (deltaX + deltaY >= 3) {
          window.revampMapInfoDragging = true;
        }
      }
      panel.style.left = nextLeft + 'px';
      panel.style.top = nextTop + 'px';
    };

    var onUp = function () {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      setTimeout(function () {
        window.revampMapInfoDragging = false;
      }, 0);
    };

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }

    document.querySelectorAll('.map-info.is-open').forEach(function (item) {
      item.classList.remove('is-open');
    });
  });
})();
